var modules_7e6c94c2 = {"pixels":"_1grxq8g"};
import "../../../assets/D-ZPQC4d.css";

export { modules_7e6c94c2 as default };
//# sourceMappingURL=pixel.module.scss.js.map
